import { render, staticRenderFns } from "./WarehouseLoadingAddress.vue?vue&type=template&id=3786f948"
import script from "./WarehouseLoadingAddress.vue?vue&type=script&lang=js"
export * from "./WarehouseLoadingAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports